import { render, staticRenderFns } from "./appSvg2.vue?vue&type=template&id=1a556696&scoped=true&"
import script from "./appSvg2.vue?vue&type=script&lang=js&"
export * from "./appSvg2.vue?vue&type=script&lang=js&"
import style0 from "./appSvg2.vue?vue&type=style&index=0&id=1a556696&scoped=true&lang=css&"
import style1 from "./appSvg2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a556696",
  null
  
)

export default component.exports